import { api } from "shared/config/api/api";
import type {
  MarkReadResponse,
  MarkedCountResponse,
  NotificationType,
} from "entities/notification";

export const readNotificationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    markNotificationRead: builder.mutation<MarkReadResponse, number>({
      query: (notificationId) => ({
        url: `/users/notifications/${notificationId}/read`,
        method: "POST",
      }),
      invalidatesTags: ["Notifications"],
    }),
    // Без type помечает все типы.
    markAllNotificationsRead: builder.mutation<
      MarkedCountResponse,
      NotificationType | void
    >({
      query: (type) => ({
        url: "/users/notifications/read-all",
        method: "POST",
        params: type ? { type } : undefined,
      }),
      invalidatesTags: ["Notifications"],
    }),
    // Помечает все ticket_reply по тикету разом.
    markTicketRead: builder.mutation<MarkedCountResponse, number>({
      query: (ticketId) => ({
        url: `/support/tickets/${ticketId}/read`,
        method: "POST",
      }),
      invalidatesTags: ["Notifications"],
    }),
  }),
});

export const {
  useMarkNotificationReadMutation,
  useMarkAllNotificationsReadMutation,
  useMarkTicketReadMutation,
} = readNotificationsApi;
